// Thumbnail/thumbnailConstants.js

export const presets = {
    vintage: {
        bgColor1: '#8B4513',
        bgColor2: '#DEB887',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '🎵',
        effect: 'leaves'
    },
    romantic: {
        bgColor1: '#FF69B4',
        bgColor2: '#FFB6C1',
        textColor: '#FFFFFF',
        bgType: 'radial',
        icon: '💕',
        effect: 'hearts'
    },
    nature: {
        bgColor1: '#228B22',
        bgColor2: '#90EE90',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '🌿',
        effect: 'flowers'
    },
    winter: {
        bgColor1: '#4682B4',
        bgColor2: '#B0E0E6',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '❄️',
        effect: 'snowflakes'
    },
    spring: {
        bgColor1: '#FFB6C1',
        bgColor2: '#98FB98',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '🌸',
        effect: 'flowers'
    },
    ocean: {
        bgColor1: '#1E90FF',
        bgColor2: '#87CEEB',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '🌊',
        effect: 'bubbles'
    },
    sunset: {
        bgColor1: '#FF4500',
        bgColor2: '#FFD700',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '🌅',
        effect: 'stars'
    },
    rainy: {
        bgColor1: '#4A5568',
        bgColor2: '#2D3748',
        textColor: '#FFFFFF',
        bgType: 'gradient',
        icon: '🌧️',
        effect: 'rainlines'
    }
};

export const effectParticles = {
    raindrops: ['💧', '💧', '💧'],
    rainlines: ['|', '|', '|'],
    snowflakes: ['❄️', '⛄', '❄️', '🌨️'],
    bubbles: ['○', '○', '○'],
    leaves: ['🍂', '🍃', '🍁', '🌿'],
    flowers: ['🌸', '🌺', '🌼', '🌻', '🌹'],
    hearts: ['💖', '💕', '💗', '💝'],
    stars: ['⭐', '✨', '🌟', '⭐']
};